import { useEffect, useState } from "react";
import FilterBar from "./FilterBar";
import api from "../../../../services/api";

function VendedorRanking() {
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState({});

  async function carregar(params = {}) {
    try {
      const res = await api.get("/v1/dashboard/rankingvendedor", {
        params: {
          dt1: params.inicio || "",
          dt2: params.fim || "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const arr = Array.isArray(res.data) ? res.data : [];

      // Apenas 5 primeiros itens
      setDados(arr.slice(0, 10));

    } catch (err) {
      console.error("Erro ranking equipes:", err);
      setDados([]);
    }
  }

  function getPrimeiroEUltimoDiaMes() {
    const hoje = new Date();

    // Primeiro dia do mês
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    // Último dia do mês
    const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

    return {
      inicio: primeiroDia.toISOString().split("T")[0],
      fim: ultimoDia.toISOString().split("T")[0]
    };
  }

  const datas = getPrimeiroEUltimoDiaMes();


  return (
    <div className="dashboard-card2">

      {/* HEADER */}
      <div className="header-row">
        <div className="dashboard-header">
          <i className="fa fa-user-tie"></i> Ranking de Vendedores
        </div>

        <button
          className="btn btn-outline-primary btn-sm btn-refresh"
          onClick={() => carregar(filtro)}
        >
          <i className="fa fa-sync"></i>
        </button>
      </div>

      <div className="dashboard-body">

        <FilterBar
          dataInicial={datas.inicio}
          dataFinal={datas.fim}
          onChange={(f) => {
            setFiltro(f);
            carregar(f);
          }}
        />

        {/* LISTAGEM */}
        <div className="list-ranking mt-3">

          {dados.length === 0 ? (
            <div>Sem dados</div>
          ) : (
            <ul className="list-group ranking-list">
              {dados.map((item, index) => (
                <li
                  key={index}
                  className="list-group-item d-flex align-items-center justify-content-between ranking-item"
                  style={{
                    borderRadius: 10,
                    marginBottom: 8,
                    padding: "12px 16px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    border: "1px solid #eee",
                  }}
                >
                  {/* POSIÇÃO */}
                  <div
                    className="ranking-posicao"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      background: "#2f80ed",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    {index + 1}
                  </div>

                  {/* DESCRIÇÃO */}
                  <div
                    className="ranking-descricao flex-grow-1"
                    style={{
                      marginLeft: 12,
                      fontSize: 15,
                      fontWeight: 500,
                      color: "#333",
                    }}
                  >
                    {item.nome}
                  </div>

                  {/* QUANTIDADE */}
                  <div
                    className="ranking-qtde"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "#2f80ed",
                    }}
                  >
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    }).format(item.qtde)}
                  </div>
                </li>
              ))}
            </ul>
          )}

        </div>

      </div>
    </div>
  );
}

export default VendedorRanking;
